import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSelectedCheck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={10} height={12} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M0.694824 5.73141C1.80932 6.49427 3.78203 8.74709 4.40185 10.2013C5.34351 6.97106 7.78704 2.32237 9.03861 0.701294" stroke="#28231F" strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgSelectedCheck);
export default ForwardRef;